import { Component, OnChanges, OnDestroy, OnInit, ViewChild } from '@angular/core';

import { ToastsManager } from "@app/shared/util/toastr.service";
import { TranslateService } from '@ngx-translate/core';

import { Subscription } from 'rxjs';

import { TableConfig } from '@app/shared/util/table-config.utils'

import { ToolRequest } from '@models/toolRequests.model';

import { NotificationService } from '@services/notification.service';

import { ConfirmationModalComponent } from '@components/confirmation-modal/confirmation-modal.component';

import { Log } from 'ng2-logger';
import { ToolTransportService } from "@services/tool-transport.service";
import {AppUtils} from "@app/shared/util/app.utils";

@Component({
    selector: 'app-atom-requests',
    templateUrl: './atom-requests.component.html',
    styleUrls: ['./atom-requests.component.scss']
})
export class AtomRequestsComponent implements OnInit, OnDestroy, OnChanges {

    @ViewChild(ConfirmationModalComponent, {static: false}) confirmationModal: ConfirmationModalComponent;

    _logger = Log.create(AtomRequestsComponent.name);

    toolRequests: ToolRequest[] = [];
    tableConfig = new TableConfig();
    isLoading = false;
    hasConfirmationInProgress = false;

    newToolRequestsSubscription: Subscription;
    selectedPlantsChangedSubscription: Subscription;


    constructor(private toolTransportService: ToolTransportService,
                private notificationService: NotificationService,
                private toastr: ToastsManager,
                private translateService: TranslateService) {
    }

    ngOnInit() {
        this.getToolRequests(this.tableConfig);
        this.newToolRequestsSubscription = this.notificationService.milkrunRequestQueueAsObservable.subscribe(
            (data) => {
                this._logger.info('milkrunRequestQueue:: Socket refreshed tool requests, retrieved data', data);
                this.getToolRequests(this.tableConfig);
            }
        );

        this.toolTransportService.loadEventObservable.subscribe(
            () => {
                this.getToolRequests(this.tableConfig);
            }
        )

        this.selectedPlantsChangedSubscription = this.notificationService.selectedPlantsChangedAsObservable.subscribe(data => {
            this.getToolRequests(this.tableConfig);
        });
    }

    ngOnChanges(): void {
        this.getToolRequests(this.tableConfig);
    }

    getToolRequests(tableConfig = this.tableConfig) {
        this._logger.info('getToolRequests:: Retrieving tool returns');
        this.isLoading = true;
        tableConfig = AppUtils.appendPlantsQuery(tableConfig);

        this.toolTransportService.getAtomRequests(tableConfig, 'LINE').subscribe(
            (data) => {
                this._logger.info('getToolRequests:: API Returned data', data);
                this.toolRequests = data['items'];
                this.tableConfig.pager.count = data['total'];
                this.isLoading = false;
            },
            (error) => {
                this._logger.error('getToolRequests:: API Returned error', error);
                this.isLoading = false;
            }
        )
    }

    onPageChange(tableState) {
        this.getToolRequests(tableState);
    }

    onLoadToolRequest(toolRequest: any) {
        this.confirmationModal.open({
            toolRequest: toolRequest,
            action: 'load'
        });
    }

    onUnloadToolRequest(toolRequest: any) {
        this.confirmationModal.open({
            toolRequest: toolRequest,
            action: 'unload'
        });
    }

    onConfirmAction(event: any) {
        this.hasConfirmationInProgress = true;
        switch (event.action) {
            case 'load':
                this.confirmLoadToolRequest(event.toolRequest);
                break;
            case 'unload':
                this.confirmUnloadToolRequest(event.toolRequest);
                break;
        }
    }

    confirmLoadToolRequest(toolRequest: ToolRequest) {
        this._logger.info("confirmLoadToolRequest:: Loading tool request for transport");
        this.toolTransportService.loadToolTransportForRequest(toolRequest.id).subscribe(
            (data) => {
                this.confirmationModal.close();
                this._logger.info('loadToolRequest:: API Returned data', data);
                this.toastr.success(this.buildLoadMessage(toolRequest.name));
                this.hasConfirmationInProgress = false;
            },
            (error) => {
                this.confirmationModal.close();
                this._logger.error('loadToolRequest:: API Returned error', error);
                this.hasConfirmationInProgress = false;
            }
        );
    }

    confirmUnloadToolRequest(toolReturn: any) {
        this._logger.info("confirmUnloadToolRequest:: Unloading tool request at line", toolReturn);
        this.toolTransportService.unloadToolTransportForReturn(toolReturn.id).subscribe(
            (data) => {
                this.confirmationModal.close();
                this._logger.info('unloadToolRequest:: API Returned data', data);
                this.toastr.info(this.buildUnloadMessage(toolReturn.name));
                this.hasConfirmationInProgress = false;
            },
            (error) => {
                this.confirmationModal.close();
                this._logger.error('unloadToolRequest:: API Returned error', error);
                this.hasConfirmationInProgress = false;
            }
        );
    }

    buildLoadMessage(toolRequestName) {
        return this.translateService.instant('milkrun.transportation-requests.toasts.toolRequestLoaded',
            {toolRequestName: toolRequestName});
    }

    buildUnloadMessage(toolRequestName) {
        return this.translateService.instant('milkrun.transportation-requests.toasts.toolRequestUnloaded',
            {toolRequestName: toolRequestName});
    }

    ngOnDestroy() {
        if (this.newToolRequestsSubscription) {
            this.newToolRequestsSubscription.unsubscribe();
        }

        if (this.selectedPlantsChangedSubscription) {
            this.selectedPlantsChangedSubscription.unsubscribe();
        }
    }

}
